// extracted by mini-css-extract-plugin
module.exports = {"articleTextLarge":"article-text-large_articleTextLarge__2QbWq"};